import * as React from 'react'

export function Youtube(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.875 4.425c-.637-.212-4.569-.425-8.5-.425s-7.862.213-8.5.425c-1.7.531-2.125 4.25-2.125 8.075 0 3.825.425 7.544 2.125 8.075.638.213 4.569.425 8.5.425s7.863-.212 8.5-.425c1.7-.531 2.125-4.25 2.125-8.075 0-3.825-.425-7.544-2.125-8.075zM10.25 17.281V7.72l6.375 4.781-6.375 4.781z"
                fill="currentColor"
            />
        </svg>
    )
}
